import actions from "./actions";

const initState = {
  surveyReport: [],
  loading: false,
};

export default function myMenuSurveyReducer(
  state = initState,
  { type, ...action }
) {
  switch (type) {
    case actions.MY_MENU_SURVEY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actions.MY_MENU_SURVEY_SUCCESS:
      return {
        ...state,
        surveyReport: action.surveyReport,
        loading: false,
      };
    default:
      return state;
  }
}
